/*
Преобразует объект {"Step1": Step1Component, "Step2": Step2Component}
в объект {"Step1": 1, "Step2": 2}
В сторе шаги нужно переключать по номеру. Чтобы не запутаться, можно
использовать эту мапу и ориентироваться на название шага
*/
export const makeStepsIndexesMap = <Step extends string>(
  steps: Record<Step, unknown>,
) => {
  const keys = Object.keys(steps) as Step[];
  return keys.reduce((acc, key, index) => {
    acc[key] = index + 1;
    return acc;
  }, {} as Record<Step, number>);
};
